export default "__VITE_ASSET__B4GBJwh3__"